export function getChangedBy(text) {
    if (!text) return '';
    
    const match = text.match(/: ([^,]+)/);
    return match ? match[1].trim() : '';
}

export function getInitialsCode(arr) {
    if (!Array.isArray(arr)) return '';
    return arr.map(str => {
        if (typeof str !== 'string') return '';
        return str
            .split('_')
            .map(word =>
                word.length === 2
                    ? word.toUpperCase()
                    : word[0] ? word[0].toUpperCase() : ''
            )
            .join('');
    }).join('_');
}

export function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export function removeUnderline(string) {
    return string.replace(/_/g, ' ')
}

export function highlightText(text, searchQuery) {
    if (!searchQuery || text === null || text === undefined) {
        return [{ text: text, highlight: false }]
    }
  
    const t = text.toString()
    const q = searchQuery.toString()
    const lowerT = t.toLowerCase()
    const lowerQ = q.toLowerCase()
  
    const parts = []
    let start = 0
    let idx = lowerT.indexOf(lowerQ)
  
    while (idx !== -1) {
        if (idx > start) {
            parts.push({ text: t.substring(start, idx), highlight: false }) // normal part
        }
  
        parts.push({ text: t.substring(idx, idx + q.length), highlight: true }) // found part
  
        start = idx + q.length
        idx = lowerT.indexOf(lowerQ, start)
    }
  
    if (start < t.length) {
        parts.push({ text: t.substring(start), highlight: false }) // rest of the text
    }

    return parts
}

export function getSafeFilenamePart(value, maxLen = 50, fallback = 'untitled_field') {
    // Note: reserved Windows device-name checks (CON/PRN/AUX/NUL/COM1../LPT1..) are not implemented.
    // If this helper is used for full filenames, add those checks separately.
    return (value ?? '').trim()
        .slice(0, maxLen)
        .replace(/[<>:"/\\|?*\u0000-\u001F]/g, '_') // invalid on Windows
        .replace(/\s+/g, '_')                       // normalize whitespace
        || fallback
}

export function removeFilenameExtension(filename) {
    if (!filename) return ''

    const lastDot = filename.lastIndexOf('.')
    return lastDot > 0 ? filename.slice(0, lastDot) : filename
}
